function Draw (gifts, onStart, onStep, onEnd) {
    this.list = gifts;
    this.current = null;
    this.index = 0;
    this.minInterval = 100;
    this.maxInterval = 400;
    this.stepInterval = 50;
    this.currentInterval = this.maxInterval;
    this.onStep = onStep;
    this.onStart = onStart;
    this.onEnd = onEnd;
    this.status = 'stop';
}

Draw.prototype = {
    constructor: Draw,
    start: function () {
        if (this.status !== 'stop') { return; }
        this.startTime = new Date().getTime();

        this.onStart();
        this.status = 'start';
        this.step();
    },
    stop: function () {
        this.immediateStop = true;
    },
    setLottery: function (endIndex) {
        var now = new Date().getTime();
        var self = this;

        if (now - this.startTime < 3000) {
            setTimeout(function () {
                self.endIndex = endIndex - (self.maxInterval - self.currentInterval) / self.stepInterval + 1;
                if (self.endIndex < 0) {
                    self.endIndex += self.list.length;
                }
            }, 3000 - now + this.startTime);
        } else {
            self.endIndex = endIndex - (self.maxInterval - self.currentInterval) / self.stepInterval + 1;
            if (self.endIndex < 0) {
                self.endIndex += self.list.length;
            }
        }
    },
    step: function () {
        var self = this;

        if (this.immediateStop) {
            this.onEnd();
            this.status = 'stop';
            this.immediateStop = false;
            return;
        }

        var timer = setTimeout(function () {
            self.onStep(self.index);
            self.index++;
            self.index >= self.list.length && (self.index = 0);

            if (self.index === self.endIndex) {
                self.status = 'end';
            }

            self.step(self.index);
        }, self.currentInterval);

        if (self.status === 'start') {
            self.currentInterval -= self.stepInterval;
        } else if (self.status === 'end') {
            self.currentInterval += self.stepInterval;
        }

        if (self.currentInterval < self.minInterval) {
            self.currentInterval = self.minInterval;
            self.status = 'process';
        } else if (self.currentInterval > self.maxInterval) {
            self.currentInterval = self.maxInterval;
            this.onEnd();
            this.status = 'stop';
            this.endIndex = void 0;
            clearTimeout(timer);
        }
    }
}

module.exports = Draw;


//////////////////
// WEBPACK FOOTER
// ./pages/new/js/draw.js
// module id = 4
// module chunks = 0